import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import modalStore, { ModalOption } from '@client/stores/modalStore';
import { Modal } from './Modal';

const SelectModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    const selectOption = option.select!;
    const [selectedValue, setSelectedValue] = useState(selectOption.selectedValue);

    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <div className="flex flex-col gap-2">
                    {selectOption.items.map((item, index) => (
                        <label
                            key={index}
                            className={twMerge('flex cursor-pointer items-center gap-3 py-2')}
                            onClick={() => {
                                const value = item.value;

                                setSelectedValue(value);

                                if (selectOption.closeOnSelect) {
                                    modalStore.setReturnValue(modalId, value);
                                }
                            }}
                        >
                            {item.icon && (
                                <div
                                    className={twMerge(
                                        'text-base-content/60 flex-shrink-0',
                                        selectedValue === item.value && 'text-base-content',
                                    )}
                                >
                                    {item.icon}
                                </div>
                            )}
                            <div className="flex-1">
                                <div
                                    className={twMerge(
                                        'text-base-content transition-all',
                                        selectedValue === item.value
                                            ? 'font-semibold'
                                            : 'font-normal',
                                    )}
                                >
                                    {item.name}
                                </div>
                            </div>
                            {selectOption.showRadio && (
                                <input
                                    type="radio"
                                    name={`select_${modalId}`}
                                    checked={selectedValue === item.value}
                                    onChange={() => {}}
                                    className="radio radio-sm flex-shrink-0"
                                />
                            )}
                        </label>
                    ))}
                </div>
            </Modal.BodyScroll>
            {!selectOption.closeOnSelect && (
                <Modal.ActionButton
                    className="mt-6"
                    modalId={modalId}
                    confirmStyle="default"
                    isShowCancel={false}
                    confirmText={selectOption.confirmText || '선택'}
                    onConfirm={() => {
                        modalStore.setReturnValue(modalId, selectedValue);
                    }}
                />
            )}
        </Modal.Dialog>
    );
});

export default SelectModal;
